import { orUndefined } from '@aloft/toolkit-shared';

import { extractAdjustmentDescription } from './extractAdjustmentDescription.ts';

export function extractCondition(sale: Element): number | undefined {
  try {
    return orUndefined(parseConditionRating)(extractAdjustmentDescription(sale, 'Condition'));
  } catch (e: unknown) {
    console.warn('Failed to parse condition', e);
    return undefined;
  }
}

function parseConditionRating(condition: string): number | undefined {
  switch (condition?.trim().toUpperCase()) {
    case 'C1':
      return 1;
    case 'C2':
      return 2;
    case 'C3':
      return 3;
    case 'C4':
      return 4;
    case 'C5':
      return 5;
    case 'C6':
      return 6;
    default:
      throw new Error(`Invalid condition provided: ${condition}`);
  }
}
